import Phaser from 'phaser'
import { Colors } from "../../consts/Colors.js"
import { tags } from "../../consts/Tags.js"

export default class RoundedButton extends Phaser.GameObjects.Container {
    constructor(scene, x, y, { width, height, text, textColor, backgroundColor, strokeColor, hoverTextColor, hoverBackgroundColor, hoverStrokeColor, fontSize = '40px', strokeWidth = 3, lockedBackgroundColor = null }) {
        // Create container
        super(scene, x, y, []);
        scene.add.existing(this);

        // Add variable
        this.scene = scene;
        this.depth = 1;

        const radius = height / 2;
        this.strokeWidth = strokeWidth;
        this.durationAnim = 400;

        this.textColor = textColor;
        this.backgroundColor = backgroundColor;
        this.strokeColor = strokeColor;
        this.hoverTextColor = hoverTextColor;
        this.hoverBackgroundColor = hoverBackgroundColor;
        this.hoverStrokeColor = hoverStrokeColor;
        this.lockedBackgroundColor = lockedBackgroundColor;

        this.text = text;
        this.locked = false;

        // Add objects
        this.rectButton = this.scene.add.rexRoundRectangle(0, 0, width, height, radius, this.backgroundColor);
        this.add(this.rectButton);

        if(this.strokeColor)
            this.rectButton.setStrokeStyle(this.strokeWidth, this.strokeColor, 1);

        this.textButton = this.scene.add.rexTagText(0, 0, this.text, {
            fontSize: fontSize,
            fontFamily: 'MassiliaMedium',
            fontStyle: 'bold',
            color: this.textColor,
            align: "center",
            wrap: {
                mode: 'word',
                width: (width - 10)
            },
            resolution: 2,
            tags: tags
        });
        this.textButton.setOrigin(0.5)


        this.add(this.textButton);

        // Add interaction
        this.setSize(this.rectButton.width, this.rectButton.height);
        this.setInteractive({ useHandCursor: true });

        this.on('pointerover', function () {
            if (!this.locked)
                this.pointerOver();
        });

        this.on('pointerout', function () {
            if (!this.locked)
                this.pointerOut();
        });

    }

    setClickFunction(func) {
        this.on('pointerup', () => {
            this.disableInteractive()
            func();
        })
    }

    pointerOver() {
        if(this.hoverBackgroundColor)
            this.rectButton.setFillStyle(this.hoverBackgroundColor, 1);
        if(this.hoverTextColor)
            this.textButton.setFill(this.hoverTextColor);
        if(this.hoverStrokeColor)
            this.rectButton.setStrokeStyle(this.strokeWidth, this.hoverStrokeColor, 1);
    }

    pointerOut() {
        if(this.backgroundColor)
            this.rectButton.setFillStyle(this.backgroundColor, 1);
        if(this.textColor)
            this.textButton.setFill(this.textColor);
        if(this.strokeColor)
            this.rectButton.setStrokeStyle(this.strokeWidth, this.strokeColor, 1);
    }

    setLocked() {
        this.disableInteractive();
        this.locked = true
        if(this.lockedBackgroundColor){
            this.rectButton.setFillStyle(this.lockedBackgroundColor, 1);
        }else{
            this.setAlpha(0.5)
        }
    }

    setUnlocked() {
        this.setInteractive();
        this.setAlpha(1)
        this.locked = false
        this.pointerOut();
    }

    // -- Modif du text
    setTextColor(color) {
        this.textColor = color
        this.textButton.setFill(color);
    }

    setTextFont(fontFamily) {
        this.textButton.fontFamily = fontFamily
    }

    setTextSize(fontSize) {
        this.textButton.fontSize = fontSize
    }

}